import { SoundType } from '../ActivityAudioProvider/types';
import { ActivityPageTypes, NavigationDirection } from '../../types';

export type Actions =
  | { type: 'HANDLE_LOADING'; payload: { loading: boolean } }
  | { type: 'SET_IS_ACTIVITY_OVER'; payload: boolean }
  | { type: 'HANDLE_SVG_LOADING'; payload: { loading: boolean } }
  | { type: 'HANDLE_ERROR'; payload: { error: Record<string, any> | null } }
  | { type: 'HANDLE_CURRENT_PAGE_COMPLETION'; payload: { completed: boolean } }
  | { type: 'ON_GAME_END'; payload: { gameEnd: boolean } }
  | { type: 'SET_DATA'; payload: ActivityData }
  | { type: 'SET_CURRENT_DATA'; payload: { currentData: any[] } }
  | { type: 'RESET_ACTIVITY'; payload: { isRestarting: boolean } }
  | { type: 'SET_SHOW_ANIMATION'; payload: { showAnimation: boolean } };

export type ActivityData = {
  activityType: string;
  letter: LetterType;
  pages: (FindTheLetterInterface | FindTheObjectInterface)[];
  instructions: string;
  hasPagination: boolean;
};

export type ActivityLoader = {
  [key: string]: (data: any) => SoundType[];
};

type LetterType = {
  character: string;
  src: string;
  vtt: string;
};

export interface PageType {
  contents: {
    description: string;
    occurences?: number;
  } | null;
  page: { pageNumber: number };
  svg: {
    src: string;
  } | null;
  words: Array<{
    description: string;
    src: string;
  }> | null;
}

export interface FindTheLetterInterface {
  pageType: ActivityPageTypes;
  page: {
    id: number;
    src?: string;
    pageNumber: number;
  };
  png?: {
    src: string;
    description?: string;
    spreadLayout: boolean;
  };
  contents: {
    description: string;
    src: string;
    vtt: string;
    isEmpty?: boolean;
    occurrences?: number;
  };
  objects: ObjectsType[];
  animation?: AnimationType;
}
export interface FindTheObjectInterface {
  page: {
    id: number;
    src: string;
    pageNumber: number;
  };
  contents: {
    svgUrl: string;
    currentPageText: string;
    occurrences?: number;
    tags: string[];
    nextPageText?: string;
    isEmpty?: boolean;
    description: string;
  };
  objects: ObjectsType[];
  svg?: {
    src: string;
  };
  animation?: AnimationType;
}

export type ObjectsType = {
  src: string;
  vtt: string;
  description: string;
  occurrences: number;
  animation: boolean;
  id: string;
};

export type AnimationType = {
  src: string;
  vtt?: string;
};

type ModalDataType = {
  title: string;
  subtitle: string;
  content: string;
  continueButtonLabel: string;
  closeButtonLabel: string;
};

export type UseGame<T> = [UseGameState<T>, UseGameDispatch];

export type UseGameState<T> = {
  activityData: ActivityData | any;
  activityState: {
    count: number;
    currentPageCompleted: boolean;
    step: number;
    gameEnd: boolean;
    showAnimation: boolean;
  };
  closeActivity: ModalDataType;
  unfinishedActivity: ModalDataType;
  currentData: T[];
  isRestarting: boolean;
  loading: boolean;
  SVGsLoading: boolean;
  error: Record<string, any> | null;
  isActivityOver: boolean;
};

export type UseGameDispatch = {
  onGameEnd: () => boolean;
  resetActivity: (isRestarting: boolean) => boolean;
  handleCurrentPageCompletion: (completed: boolean) => boolean;
  handleCurrentPageCompletionWithAlert: (completed: boolean) => boolean;
  handleRestartActivity: () => void;
  triggerActivityModal: (
    scope: string,
    onContinueActions?: () => void,
    direction?: NavigationDirection,
    onCloseActions?: () => void
  ) => void;
  handleTurnActivityPage: (direction: NavigationDirection) => void;
  handleCloseActivity: any;
  setShowAnimation: (showAnimation: boolean) => void;
};

export type WordsType = {
  src: string;
  vtt: string;
  description: string;
};

export enum ActivityTypes {
  FIND_THE_LETTER = 'FindTheLetter',
  FIND_THE_OBJECTS = 'FindTheObjects',
  SOUND_OUT_WORDS = 'SoundOutWords',
}
